import Promise from 'bluebird';
import { BaseStepView } from '@bingads-webui/steps-wizard';

/**
 * AudienceStepBase class for step views used for the Audience creation flow
 *
 * @class AudienceStepBase
 * @extends {BaseStepView}
 */
export class AudienceStepBase extends BaseStepView {
  /**
   * Implementation needed for the {BaseStepView}
   * When the cancel button is clicked, this function is called to handle.
   *
   * @returns {undefined}
   */
  cancel() {
    // TODO: (youngim) - actual proper implementation for cancel needs to be done
    return new Promise((resolve) => {
      if (window.confirm('Do you really want to cancel and leave?')) { // eslint-disable-line no-alert
        resolve(true);
      }
    }).then(() => {
      if (this.activityLogger) {
        this.activityLogger.signal('canceled', 'audience steps');
      }

      this.trigger('canceled');
    });
  }

  /**
   * Implementation needed for the {BaseStepView}
   * It tells the Wizard if the view is ready to move forward.
   *
   * @returns {Promise} - promise of returning boolean indicating if it is ready or not
   */
  wizardShouldGoNext() {
    return Promise.resolve(true);
  }

  /**
   * Implementation needed for the {BaseStepView}
   * It tells the Wizard if the view is ready to move backward.
   *
   * @returns {Promise} - promise of returning boolean indicating if it is ready or not
   */
  wizardShouldGoBack() {
    return new Promise(resolve => resolve(true));
  }
}
